import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`10. Permitted CPU, Bandwidth and Disk Usage`}</h3>
    <p>{`Server usage is limited by the resources allocated to the specific plan that You have purchased.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      